import React, { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery'
import {
    Card,
    Button,
    Grid,
    Typography,
    TextareaAutosize
} from '@mui/material';
import Login from "../MSAL/LoginRedirect"

export default function BasicGrid() {
    const match = useMediaQuery('(min-width:600px)')
    const breakpoint = match ? { width: '100%', heigth: '50vw' } : { width: '90vw', heigth: '20vw' }

    const fieldset = {
        width: '100%',
        height: '100%',
        padding: 0,
        border: '1px solid #000',
        borderRadius: 3,

        backgroundColor: "rgb(255, 255, 255,0.9)"
    }

    return (
        <Grid
            xs={12}
            container
            alignItems="center"
            justifyContent="center"
            sx={{ paddingTop: 10, ...fieldset }}>




            <Grid
                sx={{ paddingTop: 4 }} item xs={12}>
                <Typography sx={{ marginX: 2 }}>

                    <h3 style={{ color: "rgb(37,44,95)" }}>Ha finalizado el proceso CAE</h3>

                    <h4 style={{ color: "red" }}> Error de acceso</h4>
                    <h4 style={{ color: "rgb(37,44,95)" }}>Comuniquese con UFE </h4>
                    <a href="mailto:ufe@ugm.cl" style={{ color: "red" }}>ufe@ugm.cl </a>
                </Typography>

            </Grid>

            <Grid container justify="center" sx={{ marginX: 1 }} >
                <Grid item md={12}>


                    <Grid sx={{ marginY: 10 }} />

<Login/>

                </Grid>
            </Grid>
        </Grid >

    )







}